import React from 'react';

import Time from '../Time';

import S from './LockScreenHeader.module.css';

const weekDays = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday'
];
const yearMonth = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
];

const LockScreenHeader = ({ isLocked }) => {
  const date = new Date();
  const dd = weekDays[date.getDay()];
  const mm = yearMonth[date.getMonth()];

  return (
    <div className={S.root} data-is-locked={isLocked.toString()}>
      <div className={S.time}>
        <Time />
      </div>
      <div className={S.date}>
        {dd}, {mm} {date.getDate()}
      </div>
    </div>
  );
};

export default LockScreenHeader;
